export class Tabs<T extends string = string> {
    TAB: {[K in T]: K};
    selectedTabIndex: number;

    private tabs: {value: T, visible: boolean, marked: boolean}[];

    private constructor(...tabs: T[]) {
        this.TAB = Object.fromEntries(tabs.map(tab => [tab, tab])) as {[K in T]: K};
        this.tabs = tabs.map(it => ({value: it, visible: true, marked: false}));
        this.selectedTabIndex = 0;
    }

    get values(): T[] {
        return this.tabs.filter(it => it.visible).map(it => it.value);
    }

    get selectedTab(): T {
        return this.values[this.selectedTabIndex] || this.values[0];
    }

    set selectedTab(tab: T) {
        const idx = this.values.indexOf(tab);
        this.selectedTabIndex = idx >= 0 ? idx : 0;
    }

    static of<R extends readonly string[]>(...tabs: R): Tabs<R[number]> {
        return new Tabs(...tabs);
    }

    show(tab: T, show = true): void {
        const aTab = this.tabs.find(it => it.value === tab);
        if (aTab) {
            aTab.visible = show;
        }
    }

    mark(tab: T, marked = true): void {
        const aTab = this.tabs.find(it => it.value === tab);
        if (aTab) {
            aTab.marked = marked;
        }
    }

    isMarked(tab: T): boolean {
        return !!this.tabs.find(it => it.value === tab)?.marked;
    }
}
